import axios from 'axios'
import { getAbsoluteBackendURL } from '@/utils/backend'
import { sendEnhancedErrorToSentry } from '@/utils/error-monitoring/send-enhanced-error.js'

const client = axios.create({
  baseURL: getAbsoluteBackendURL('/checkout/v1'),
  withCredentials: true,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
})

client.interceptors.response.use(
  response => response,
  (error) => {
    sendEnhancedErrorToSentry(error)
    return Promise.reject(error)
  },
)

export default client
